import React, {useContext} from "react"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import {emptySearchLabels} from "../../constants"
import WhatsAppButton from "../navigation/WhatsAppButton"
import {ModalContext} from "../../context/ModalContext"
import AnalyticsContext from "../../context/AnalyticsContext"
import BookAppointmentModalContent from "../reusable/ModalsContent/BookAppointmentModalContent"
import {gaCategories, gaEvents} from "../../config/googleAnalytics/events"
import {useRouter} from "next/router"
import urlParams from "../../utility/UrlParams"
import {defaultValue} from "../filter/Config"

function EmptySearchResults() {
	const {t} = useTranslation()
	const {setModalContent, openModal, closeModal} = useContext(ModalContext)
	const router = useRouter()
	const params = router.query
	const filterSearchValue = params[urlParams.searchValue] ? params[urlParams.searchValue] === defaultValue ? "" : params[urlParams.searchValue] : ""
	const {reactGA} = useContext(AnalyticsContext)
	return (
		<div style={{backgroundColor: "#F8F8F8", borderRadius: "16px", rowGap: "24px", padding: "40px 16px"}}
			className="alert d-flex flex-column align-items-center justify-content-center"
			role="alert">
			<Typography variant="heading3Black"
				style={{fontSize: "36px", lineHeight: "44px"}}>
				{t("no-search-results-found")}
				{" \"" + decodeURI(filterSearchValue.toString()) + "\""}
			</Typography>
			<div style={{columnGap: "80px"}}
				className="d-flex col-12 flex-md-row flex-column justify-content-center align-items-start">
				{emptySearchLabels.map((labelsArray, parentIndex) => (
					<ul key={parentIndex}
						style={{rowGap: "14px"}}
						className={`d-flex justify-content-start align-items-start flex-column ${parentIndex === 0 ? "py-0 px-4 m-4 p-lg-auto my-lg-auto" : "list-unstyled"}`}>
						{labelsArray.map((label, index) => (
							<li style={{maxWidth: index > 0 ? "201px" : ""}}
								onClick={() => {
									if (parentIndex !== 1) {
										return null
									}

									if (index === 2) {
										reactGA?.event({
											category: gaCategories.consultation,
											action: gaEvents.freeServicesDropdown,
											label: `${gaCategories.consultation} - ${gaEvents.freeServicesDropdown}`,
											nonInteraction: false
										})

										setModalContent(<BookAppointmentModalContent closeModal={closeModal}/>)
										openModal()
									}

									if (index === 3) {
										router.push("mailto:sales@mybikeplan.ch")
									}
								}}
								className={` ${parentIndex === 1 && index > 1 ? "cursor-pointer" : ""} ${parentIndex === 2 || (parentIndex === 0 && index === 0) ? "d-flex justify-content-start flex-column align-items-start gap-2" : ""} `}
								key={index}>
								<Typography
									variant={index === 0 ? "bodySmBold" : parentIndex === 0 ? "bodySm" : "bodySmBold"}
									style={{marginLeft: (parentIndex === 0 && index === 0) ? "-16px" : "0rem", padding: "0px 5px", background: parentIndex === 1 && index > 0 ? "#FFE9C2" : "", borderRadius: "5px", marginBottom: index === 0 ? "8px" : ""}}>
									{t(label)}
								</Typography>
								{parentIndex === 2 ? <WhatsAppButton /> : null}</li>
						))}
					</ul>
				))}
			</div>
		</div>
	)
}

export default EmptySearchResults
